/* eslint-disable camelcase */
import React from 'react';

import ItemOptionPresentation from './ItemOptionPresentation';

export default class ItemOption extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showAllTextOption: false,
        };
    }

    handleShowAllTextOption(currentShowAllTextOption) {
        this.setState({ showAllTextOption: !currentShowAllTextOption });
    }

    render() {
        const { option, correct_question_id } = this.props;
        const { showAllTextOption } = this.state;
        return (
            <ItemOptionPresentation
                correct_question_id={correct_question_id}
                option={option}
                handleShowAllTextOption={this.handleShowAllTextOption.bind(
                    this,
                )}
                showAllTextOption={showAllTextOption}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/questions-database/components/ItemOption/index.js